export type ArmhrApp = 'hcm' | 'quote' | 'ops';

const DEV_URL: Record<ArmhrApp, string> = {
  hcm: 'http://localhost:3200',
  quote: 'http://localhost:3300',
  ops: 'http://localhost:3500',
};

const STAGING_URL: Record<ArmhrApp, string> = {
  hcm: 'https://app.staging.armhr.com',
  quote: 'https://quote.staging.armhr.com',
  ops: 'https://ops.staging.armhr.com',
};

const PROD_URL: Record<ArmhrApp, string> = {
  hcm: 'https://app.armhr.com',
  quote: 'https://quote.armhr.com',
  ops: 'https://ops.armhr.com',
};

const ENV_OVERRIDE: Record<ArmhrApp, string | undefined> = {
  hcm: import.meta.env.VITE_APP_HCM_URL,
  quote: import.meta.env.VITE_APP_QUOTE_URL,
  ops: import.meta.env.VITE_APP_OPS_URL,
};

/**
 * Resolve the base URL for one of the frontend apps
 * explicit env override -> local dev -> staging -> prod.
 */
export const getAppUrl = (app: ArmhrApp): string => {
  const override = ENV_OVERRIDE[app];
  if (override) return override;
  if (import.meta.env.DEV) return DEV_URL[app];
  if (import.meta.env.MODE === 'staging') return STAGING_URL[app];
  return PROD_URL[app];
};
